import React from "react";

export default function SeverityBadge({ severity = "Low" }) {
  const cls = {
    Critical: "qt-sev qt-sev-critical",
    High:     "qt-sev qt-sev-high",
    Moderate: "qt-sev qt-sev-moderate",
    Medium:   "qt-sev qt-sev-medium",
    Low:      "qt-sev qt-sev-low",
    Info:     "qt-sev qt-sev-info",
  }[severity] || "qt-sev qt-sev-info";
  return (
    <span className={cls} data-testid={`severity-badge-${severity.toLowerCase()}`}>
      {severity}
    </span>
  );
}
